// extracted by mini-css-extract-plugin
module.exports = {"ManualTopListOverview":"Archive_ManualTopListOverview__qlj2M","TopList":"Archive_TopList___B8N0","Advertisement":"Archive_Advertisement__3zs5I"};